/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-13 11:51:46
 */
/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj (url) {
  const search = url && url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * 数字转化为中文汉字
 * @param {Object} num
 */
export function NumberToChinese (num) {
  var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var chnUnitSection = ['', '万', '亿', '万亿', '亿亿']
  var unitPos = 0
  var strIns = ''
  var chnStr = ''
  var needZero = false

  if (num === 0) {
    return chnNumChar[0]
  }

  while (num > 0) {
    var section = num % 10000
    if (needZero) {
      chnStr = chnNumChar[0] + chnStr
    }
    strIns = SectionToChinese(section)
    strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0]
    chnStr = strIns + chnStr
    needZero = section < 1000 && section > 0
    num = Math.floor(num / 10000)
    unitPos++
  }

  return chnStr
}
/**
 * 节内转换算法
 * @param {Object} section
 */
export function SectionToChinese (section) {
  var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']

  var chnUnitChar = ['', '十', '百', '千']
  var strIns = ''
  var chnStr = ''
  var unitPos = 0
  var zero = true
  while (section > 0) {
    var v = section % 10
    if (v === 0) {
      if (!zero) {
        zero = true
        chnStr = chnNumChar[v] + chnStr
      }
    } else {
      zero = false
      strIns = chnNumChar[v]
      strIns += chnUnitChar[unitPos]
      chnStr = strIns + chnStr
    }
    unitPos++
    section = Math.floor(section / 10)
  }
  return chnStr
}

export const getSafariDate = (dateStr) => {
  return dateStr.replace(/-/g, '/')
}

/**
 * 深度拷贝
 */
export function deepClone(source, hash = new WeakMap()) {
  // 基本类型直接返回
  if (source === null || typeof source !== 'object') {
    return source
  }

  // 处理循环引用
  if (hash.has(source)) {
    return hash.get(source)
  }

  // 处理 Date 对象
  if (source instanceof Date) {
    return new Date(source)
  }

  // 处理 RegExp 对象
  if (source instanceof RegExp) {
    return new RegExp(source)
  }

  // 处理 Map 对象
  if (source instanceof Map) {
    const cloneMap = new Map()
    hash.set(source, cloneMap)
    source.forEach((value, key) => {
      cloneMap.set(deepClone(key, hash), deepClone(value, hash))
    })
    return cloneMap
  }

  // 处理 Set 对象
  if (source instanceof Set) {
    const cloneSet = new Set()
    hash.set(source, cloneSet)
    source.forEach(value => {
      cloneSet.add(deepClone(value, hash))
    })
    return cloneSet
  }

  // 处理数组和普通对象
  const cloneObj = Array.isArray(source) ? [] : {}
  hash.set(source, cloneObj)

  // 使用 Reflect 获取所有属性（包括 Symbol）
  const keys = Reflect.ownKeys(source)
  for (const key of keys) {
    cloneObj[key] = deepClone(source[key], hash)
  }

  return cloneObj
}



// WEBPACK FOOTER //
// ./src/utils/index.js